module.exports = __webpack_public_path__ + "assets/img/flow.14975a5a.svg";